import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
//import { MoonLoader as Loader } from "react-spinners";
import styled, {withTheme, css} from 'styled-components';
import Popup from '../containers/popup';
import Icon from '../icon';
import { defaultTheme } from '../../data/themes';

//import Button from './button';


import { triggerActionEvent } from './common';
import { getPhrase } from '../../data/phrases';

function isSet(value) {
	return value !== null && value !== undefined;
}



const LookupInputWrapper = styled.div`
	position: relative;
	background: ${props => props.theme.inputBackground ?? defaultTheme.inputBackground};
	color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};
	border: ${props => props.theme.inputBorder ?? defaultTheme.inputBorder};
	border-radius: ${props => props.theme.inputBorderRadius ?? defaultTheme.inputBorderRadius};
	outline: ${props => props.theme.inputOutline ?? defaultTheme.inputOutline};
	padding: ${props => props.theme.inputPadding ?? defaultTheme.inputPadding};

	&::selection {
		background: ${props => props.theme.inputSelectionBackground ?? defaultTheme.inputSelectionBackground};
		color: ${props => props.theme.inputSelectionColor ?? defaultTheme.inputSelectionColor};
	}

	&.readonly {
		background: ${props => props.theme.inputReadOnlyBackground ?? defaultTheme.inputReadOnlyBackground};
		color: ${props => props.theme.inputReadOnlyColor ?? defaultTheme.inputReadOnlyColor};
	}

	&.combo:not(.readonly) {
		input {
			cursor: pointer;
		}
	}

	> .layout {
		position: relative;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};

		input {
			flex-grow: 1;
			border: none;
			outline: none;
			width: 100%;
			font-weight: ${props => props.theme.inputFontWeight ?? defaultTheme.inputFontWeight};
			font-size: ${props => props.theme.inputFontSize ?? defaultTheme.inputFontSize};
			padding: 0px 2px;
			color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};
			background: transparent;
			text-align: ${props => props.textAlign};

			&::selection {
				background: ${props => props.theme.inputSelectionBackground ?? defaultTheme.inputSelectionBackground};
				color: ${props => props.theme.inputSelectionColor ?? defaultTheme.inputSelectionColor};
			}

			&[readonly] {
				color: ${props => props.theme.inputReadOnlyColor ?? defaultTheme.inputReadOnlyColor};
			}

			::placeholder {
				color: ${props => props.theme.inputPlaceholderColor ?? defaultTheme.inputPlaceholderColor};
				font-weight: ${props => props.theme.inputPlaceHolderFontWeight ?? defaultTheme.inputPlaceHolderFontWeight};
			}

		}
		> .icon {
			position: relative;
			top: -1px;
			color: ${props => props.theme.lookupInputIconColor ?? props.theme.inputColor ?? defaultTheme.inputColor} !important;
			flex-grow: 0;
			font-size: 12px;
			padding-left: ${props => props.theme.lookupInputIconHorizontalPadding ?? defaultTheme.lookupInputIconHorizontalPadding};
			padding-right: ${props => props.theme.lookupInputIconHorizontalPadding ?? defaultTheme.lookupInputIconHorizontalPadding};
			&[data-name=clear] {
				margin-right: ${props => props.theme.lookupInputClearIconMarginRight};
			}
		}
	}
`;

/*
	input {
		font-weight: 600;
		font-size: 14px;
		padding: 0px;
		width: 100%;
		border: none;
		outline: none;
		&::selection {
			background: #3A3A3A;
			color: #ffffff;
		}
	}

*/

const PopupMessage = styled.div`
	padding: 4px;
	text-align: center;
`;

export default class LookupInput extends React.PureComponent {

	constructor() {
		super();
		this.state = {
			text: '',
			popupOpen: false,
			rows: Immutable.List([])
		};
		this.onKeyDown = this.onKeyDown.bind(this);
		this.onHideRequested = this.onHideRequested.bind(this);
		this.onInputMouseDown = this.onInputMouseDown.bind(this);
		this.onRowSelected = this.onRowSelected.bind(this);
		this.onTextChange = this.onTextChange.bind(this);
		this.onSelectedRowElementChanged = this.onSelectedRowElementChanged.bind(this);
		this.clear = this.clear.bind(this);

		this.containerRef = React.createRef();
		this.popupRef = React.createRef();
		this.inputRef = React.createRef();

		this.getPopupAnchor = this.getPopupAnchor.bind(this);
	}

	setSelectedValue(selectedKey) {
		this.setState({
			selectedIndex: this.getIndex(this.state.rows, selectedKey),
			selectedKey
		});
	}

	clear() {
		this.onChange(null, '');
	}

	onRowSelected(selected) {
		this.closePopup();
		this.onChange(selected);
	}

	getIndex(rows, key) {
		return rows.findIndex(row => row.get('key') === key)
	}

	async updateRows(filter) {
		this.setState({
			requestPending: true
		});
		var rows = await this.props.getRows(filter);
		if (!rows) {
			return;
		}
		let selectedKey = this.state.selectedKey;
		let selectedIndex = this.getIndex(rows, this.state.selectedKey);
		if (selectedIndex < 0) {
			selectedIndex = 0;
			selectedKey = rows.getIn([0, 'key']);
		}
		this.setState({
			requestPending: false,
			rows,
			selectedIndex,
			selectedKey
		});
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.value != prevState.value) {
			return {
				value: nextProps.value,
				selectedKey: nextProps.value,
				text: '',
				filter: null
			}
		} else {
			return null;
		}

	}

	onSelectedRowElementChanged(row) {
		let vp = this.popupRef.current;
		if (!vp) {
			return;
		}
		vp = vp.container;
		const vpRect = vp.getBoundingClientRect();
		const rowRect = row.getBoundingClientRect();
		let moveBy = 0;
		if (rowRect.bottom > vpRect.bottom) {
			moveBy = rowRect.bottom - vpRect.bottom + 2;
		} else if (rowRect.top < vpRect.top) {
			moveBy = rowRect.top - vpRect.top - 2;
		}
		if (moveBy) {
			vp.scrollTop += moveBy;
		}
	}

	async updateText() {
		this.setState({
			requestPending: true
		});
		let text = await this.props.getText(this.state.value);
		let error = null;
		if (text && typeof text === 'object') {
			error = text.type || null;
			text = text.text;
		}
		if (!this._unmounted) {
			this.setState({
				text: text || '',
				requestPending: false,
				error
			});
		}
	}

	componentDidMount() {
		this.updateText();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			this.updateText();
		} else if (this.props.textRefreshTimestamp > prevProps.textRefreshTimestamp) {
			this.updateText();
		}
	}

	componentWillUnmount() {
		this._unmounted = true;
	}

	move(offset) {
		const rows = this.state.rows;
		let selectedIndex = this.state.selectedIndex + offset;
		if (selectedIndex < 0) {
			selectedIndex = 0;
		} else if (selectedIndex >= rows.size) {
			selectedIndex = rows.size - 1;
		}
		this.setState({
			selectedIndex,
			selectedKey: rows.getIn([selectedIndex, 'key'])
		});
	}

	onChange(value, filter) {
		if (typeof this.props.onChange === 'function') {
			this.props.onChange(value, filter);
		}
	}

	clearTimeout() {
		if (this.timeoutId) {
			window.clearTimeout(this.timeoutId);
			this.timeoutId = null;
		}
	}

	openPopup(filter) {
		this.clearTimeout();
		this.setState({
			filter,
			popupOpen: true
		});
		this.updateRows(filter);
	}

	closePopup() {
		let filter = this.state.filter;
		if (filter === '') {
			filter = null;
		}
		this.setState({
			popupOpen: false,
			filter
		});
	}

	onKeyDown(e) {
		const keyCode = e.keyCode;
		if (keyCode === 40) {
			this.move(1);
		} else if (keyCode === 38) {
			this.move(-1);
		} else if (keyCode === 13) {
			if (this.timeoutId) {
				this.clearTimeout();
				this.openPopup(this.state.filter);
				e.preventDefault();
				return;
			}
			let fireAction = true;
			let softAction = false;
			if (this.state.popupOpen) {
				softAction = true;
				if (this.state.rows.size > 0) {
					e.preventDefault();
				}
				const filter = this.state.filter;
				this.closePopup();
				if (isSet(this.state.selectedKey)) {
					this.onChange(this.state.selectedKey, filter);
				}
			} else if (e.ctrlKey) {
				e.nativeEvent.preventDefault();
				this.openPopup('');
				fireAction = false;
			}
			if (fireAction) {
				if (this.props.suppressItemAction) {
					if (this.props.onSuppressedAction) {
						this.props.onSuppressedAction(e, softAction);
					}
				} else {
					triggerActionEvent(e.target);
				}
			}
		} else if (keyCode === 27) {
			if (this.state.popupOpen) {
				e.preventDefault();
			}
			this.setState({
				popupOpen: false,
				filter: null
			});
		} else if ((keyCode === 46) && e.ctrlKey) {
			this.closePopup();
			if (!this.props.readOnly && !this.props.mandatory) {
				this.clear();
			}
		}

		if (this.props.onKeyDown) {
			this.props.onKeyDown(e);
		}
	}

	onHideRequested() {
		this.closePopup();
	}


	onTextChange(e) {
		if (this.timeoutId) {
			this.clearTimeout();
		}
		const filter = e.target.value;
		let timeout = this.props.timeout || 0;
		if (this.state.filter && (this.state.filter.length === (filter.length - 1))) {
			if (filter.endsWith(' ')) {
				timeout = 0;
			}
		}
		if (typeof this.props.onTextChange === 'function') {
			this.props.onTextChange(filter);
		}
		if (timeout === 0) {
			this.openPopup(filter);
		} else {
			this.setState({
				filter
			});
			this.timeoutId = window.setTimeout(() => {
				this.openPopup(filter);
			}, timeout);
		}
	}

	getPopupAnchor() {
		let el = this.containerRef.current;
		let formItem = el.closest('.ps-lookupAnchor');
		if (formItem) {
			el = formItem;
		}
		return el.getBoundingClientRect();
	}

	onInputMouseDown(e) {
		if (this.props.combo && !this.props.readOnly) {
			if (this.state.popupOpen) {
				return;
			}
			window.setTimeout(() => {
				this.openPopup('');
			}, 0);
		}
	}

	render() {
		const hasValue = (this.props.value !== null) && (typeof this.props.value !== 'undefined');
		return (
			<LookupInputWrapper
				width={this.props.width}
				data-name={this.props.name}
				data-value={this.props.value}
				textAlign={this.props.textAlign}
				className={
					'component ps-input lookup ' +
					(hasValue ? 'set' : 'empty') +
					(this.props.readOnly ? ' readonly' : '') +
					(this.props.combo ? ' combo' : '') +
					(' ' + (this.props.className || '')) +
					(' ' + (this.state.error || ''))
				}
				ref={this.containerRef}
			>
				<div className="layout">
				{
					hasValue && !this.props.readOnly && !this.props.mandatory && (
						<Icon
							name="clear"
							active
							onMouseDown={e => {
								e.preventDefault();
								this.clear();
								this.inputRef.current.focus();
							}}
						/>

					)
				}
				<input
					type="text"
					className={'text lookup' + (this.props.readOnly ? ' readOnly' : '')}
					data-autofocusid={this.props.autoFocusId}
					ref={this.inputRef}
					value={typeof this.state.filter === 'string' ? this.state.filter : this.state.text}
					onChange={this.onTextChange}
					onKeyDown={this.onKeyDown}
					spellCheck="false"
					title={this.props.hint}
					readOnly={this.props.readOnly}
					tabIndex={this.props.readOnly ? '-1' : '0'}
					placeholder={this.state.text || this.props.placeholder}
					size={this.props.size}
					onBlur={e => {
						if (typeof this.props.onBlur === 'function') {
							this.props.onBlur(e);
						}
						this.setState({
							filter: null,
							popupOpen: false
						})
					}}
					onMouseDown={this.onInputMouseDown}
				/>
				{
					this.state.requestPending ? (
						<div className="loader">
{/*							<Loader size="14px"/>*/}
							<Icon
								name="spinner"
								spin
							/>
						</div>
					) : this.props.readOnly || this.props.noDropDown ? null : (
						<Icon
							name="dropDown"
							active
							onMouseDown={e => {
								e.preventDefault();
								if (this.state.popupOpen) {
									return;
								}
								window.setTimeout(() => {
									this.openPopup('');
									this.inputRef.current.focus();
								}, 0);
							}}
						/>
					)
				}
				</div>
				{
					this.state.popupOpen && (!this.props.hideEmptyPopup || (this.state.rows.size > 0)) && (
						<Popup
							getAnchor={this.getPopupAnchor}
							onHideRequested={this.onHideRequested}
							ref={this.popupRef}
							//className="lookup"
							minWidth={this.props.minPopupWidth}
							lookup
						>
							{
								this.state.rows.size === 0 ?
									(
										<PopupMessage>
											{this.state.requestPending ? getPhrase('readingItems') : getPhrase('noItemsFound')}
										</PopupMessage>
									)
									:
									<SimpleTable
										rows={this.state.rows}
										onRowSelected={this.onRowSelected}
										selectedKey={this.state.selectedKey}
										onSelectedRowElementChanged={this.onSelectedRowElementChanged}
										noDelete={this.props.mandatory}
									/>
							}
						</Popup>
					)
				}
			</LookupInputWrapper>
		);
	}
}

LookupInput.propTypes = {
	value: PropTypes.any,
	getRows: PropTypes.func.isRequired,
	getText: PropTypes.func.isRequired,
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	timeout: PropTypes.number,
	hideEmptyPopup: PropTypes.bool,
	onTextChange: PropTypes.func,
	onBlur: PropTypes.func
};


const SimpleTableWrapper = styled.table`
	width: 100%;
	td {
		font-size: ${props => props.theme.lookupPopupFontSize || '14px'};
		font-weight: ${props => props.theme.lookupPopupFontWeight};
		cursor: pointer;
		padding: ${props => props.theme.lookupPopupCellPadding || '2px 16px'};
		${props => props.noDelete && css`
			&:first-child {
				padding-left:  ${props => props.theme.lookupPopupNoDeleteLeftPadding || '4px'};
			}
		`}
		white-space: nowrap;
		.text {
			padding: ${props => props.theme.lookupPopupCellTextPadding};
		}
	}
	tr.selected {
		background: ${props => props.theme.lookupPopupSelectedRowBackground || defaultTheme.lookupPopupSelectedRowBackground};
		color: ${props => props.theme.lookupPopupSelectedRowColor || defaultTheme.lookupPopupSelectedRowColor};
		td {
			font-weight: ${props => props.theme.lookupPopupSelectedRowFontWeight || defaultTheme.lookupPopupSelectedRowFontWeight};
			.text {
				border-bottom: ${props => props.theme.lookupPopupSelectedRowCellTextBottomBorder};
			}
		}
	}
	tr:hover:not(.selected) {
		background: ${props => props.theme.lookupPopupHoverRowBackground || defaultTheme.lookupPopupHoverRowBackground};
		color: ${props => props.theme.lookupPopupHoverRowColor || defaultTheme.lookupPopupHoverRowColor};
		td {
			text-decoration: ${props => props.theme.lookupPopupHoverRowTextDecoration};
			font-weight: ${props => props.theme.lookupPopupHoverRowFontWeight || defaultTheme.lookupPopupHoverRowFontWeight};
		}
	}
`;

class SimpleTable extends React.PureComponent {
	constructor() {
		super();
		this.selectedRowRef = React.createRef();
	}

	onSelectedRowElementChanged() {
		const row = this.selectedRowRef.current;
		if (row && (typeof this.props.onSelectedRowElementChanged === 'function')) {
			this.props.onSelectedRowElementChanged(row);
		}
	}

	componentDidMount() {
		this.onSelectedRowElementChanged();
	}

	componentDidUpdate() {
		this.onSelectedRowElementChanged();
	}

	render() {
		const selectedKey = this.props.selectedKey;
		return (
			<SimpleTableWrapper className="component simpletable" noDelete={this.props.noDelete}>
				<tbody>
				{
					this.props.rows.map(row => {
						const key = row.get('key');
						const selected = selectedKey === key;
						return (
							<tr
								key={key}
								className={selected ? 'selected' : ''}
								ref={selected ? this.selectedRowRef : null}
								onMouseDown={e => {
									e.preventDefault();
									if (typeof this.props.onRowSelected === 'function') {
										this.props.onRowSelected(key);
									}
								}}
							>
								{
									row.get('cells').map((cell, index) => {
										return (
											<td key={index}><span className="text">{cell}</span></td>
										)
									})
								}
							</tr>
						);
					})
				}
				</tbody>
			</SimpleTableWrapper>
		)
	}
}

